import { Toaster as Sonner, type ToasterProps } from "sonner";

// shadcn-style wrapper. Hardcoded theme="dark" since the chassis is
// dark-default — no next-themes / theme provider in core.
export function Toaster(props: ToasterProps) {
	return (
		<Sonner
			theme="dark"
			className="toaster group"
			style={
				{
					"--normal-bg": "var(--color-popover)",
					"--normal-text": "var(--color-popover-foreground)",
					"--normal-border": "var(--color-border)",
					"--success-bg": "var(--color-popover)",
					"--success-text": "var(--color-semantic-success)",
					"--error-bg": "var(--color-popover)",
					"--error-text": "var(--color-destructive)",
				} as React.CSSProperties
			}
			{...props}
		/>
	);
}
